const { cxt } = require('./context');

const unitNumber = [
  'whitespace',
  'alphanumeric',
];

const streetNumber = [
  'required',
  'whitespace',
  'alphanumeric',
  cxt('max-length', { length: 6 }),
];

const streetName = [
  'required',
  'whitespace',
  cxt('pattern', { pattern: /^[a-zA-Z-' ']+$/ })
];

const streetType = [
  'required'
];

const suburb = [
  'required',
  'whitespace',
  cxt('pattern', { pattern: /^[a-zA-Z-' ']+$/ })
];

const nonAuSuburb = [
  'whitespace',
  cxt('pattern', { pattern: /^[a-zA-Z-' ']+$/ })
];

const state = [
  'required',
  'whitespace',
  cxt('pattern', { pattern: /^[a-zA-Z-' ']+$/ })
];

const country = [
  'required'
];

const address = [
  'whitespace',
  'alphanumeric-special',
];

const addressRequired = [
  'required',
  'whitespace',
  'alphanumeric-special',
];

const postcode = [
  'cardinal',
  cxt('min-length', { length: 4, isTrim: true }),
  cxt('max-length', { length: 4, isTrim: true }),
];

const postcodeRequired = [
  'required',
  'cardinal',
  cxt('min-length', { length: 4, isTrim: true }),
  cxt('max-length', { length: 4, isTrim: true }),
];

const monthsAtResidence = [
  'numeric',
  cxt('max', { limit: 11, isTrim: true })
];

const monthsAtResidenceRequired = [
  'required',
  'numeric',
  cxt('max', { limit: 11, isTrim: true })
];

const yearsAtResidence = [
  'numeric'
];

const yearsAtResidenceRequired = [
  'required',
  'numeric'
]
const nonAuPostcode = [
  'cardinal',
];
const nonAuPostcodeRequired = [
  'required',
  'cardinal',
];

module.exports = {
  unitNumber,
  streetNumber,
  streetName,
  streetType,
  suburb,
  nonAuSuburb,
  state,
  country,
  address,
  addressRequired,
  postcode,
  postcodeRequired,
  monthsAtResidence,
  yearsAtResidence,
  monthsAtResidenceRequired,
  yearsAtResidenceRequired,
  nonAuPostcode,
  nonAuPostcodeRequired,
};
